<template>
  <v-card class="card">
    <v-card-text class="pa-2">
      <pie-chart :data="data" legend="right" :donut="true"  title="blocked in country"></pie-chart>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      data: {'USA': 90, 'China': 70, 'Russia': 40, 'Germany': 30, 'United Kingdom': 35, 'Turkey': 22}
    }
  },
    created () {
      this.initialize()
    },
   methods: {
        initialize () {
         if(localStorage.getItem('access_token')!=null){ this.$http.defaults.headers.common['X-Authorization'] =  localStorage.getItem('access_token');}

          this.$http
              .get(this.$root.apiUrl+'/api/v1/statistic/bl_country')
              .then(r => {
                // console.log('r: ', JSON.stringify(r, null, 2));
                if(r.status === 200){
                  this.data = r.data;
                }

      });
     }
   }

}
</script>

<style>
  .card {
    border-radius: 3px;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, 0.125);
    box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.21);
    background-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/components/statistics/LocationStatistic.vue